import { lazy, Suspense, useEffect, useState } from 'react';
import { isMobileViewport } from '../../util/isMobileViewport';
import { scheduleDeferred } from '../../util/scheduleDeferred';

const ChatIconComponent = lazy(() =>
    import('./ChatIcon').then((m) => ({ default: m.ChatIconComponent })),
);

type DeferredChatIconProps = {
    onOpenChat: () => void;
};

/** Loads chat FAB after idle so it does not compete with homepage LCP. */
export function DeferredChatIcon({ onOpenChat }: DeferredChatIconProps) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const delayMs = isMobileViewport() ? 8000 : 4000;
        scheduleDeferred(() => setShow(true), delayMs);
    }, []);

    if (!show) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <ChatIconComponent onOpenChat={onOpenChat} />
        </Suspense>
    );
}
